import { createSlice } from "@reduxjs/toolkit";
import { addAssignedEvent } from "../../actions/events/addAssignedEvent";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const addAssignedEventSlice = createSlice({
  name: "addAssignedEvent",
  initialState,
  reducers: {
    clearaddAssignedEventsState: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addAssignedEvent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAssignedEvent.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(addAssignedEvent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearaddAssignedEventsState } = addAssignedEventSlice.actions;
export default addAssignedEventSlice.reducer;
